<div class="trip-detail-popup-right">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
</div>

<div class="orders">
  <div>
    <p>Add Orders</p>
  </div>
  <mat-divider></mat-divider>
  <form action="" class="add_orders">
    <div class="input-fileds-container">
      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-12">
              <mat-label>From</mat-label>
              <mat-form-field>
                <input matInput />
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <mat-label>To</mat-label>
              <mat-form-field>
                <input matInput />
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <mat-label>Date</mat-label>
              <mat-form-field>
                <input matInput />
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-label>Price</mat-label>
              <mat-form-field>
                <input matInput />
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <mat-label>Truck no</mat-label>
              <mat-form-field>
                <input matInput />
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <mat-divider></mat-divider> -->
    <div>Fare Breakup</div>
    <div class="row">
      <div class="col-md-6">
        <div class="card-details card-details-total">
          <div class="trip-details-left">Route Fare</div>
          <div class="trip-details-right">₹ 1,00,000</div>
          <div>Deductions</div>
          <div class="trip-details-left">GST Deductions(12%)</div>
          <div class="trip-details-right">₹ 12,000</div>
          <div class="trip-details-left">S9 Service Fee</div>
          <div class="trip-details-right">₹ 3,000</div>
          <div class="trip-details-left">S9 GST</div>
          <div class="trip-details-right">₹ 5,400</div>
        </div>
        <mat-divider></mat-divider>
        <div class="trip-details-left">Total Fare</div>
        <div class="trip-details-left">(Route Fare after deductions)</div>
        <div class="trip-details-right">₹ 91,500</div>
      </div>
    </div>
    <button type="button" class="button buttonBlue">Update Route</button>
  </form>
</div>
